import { useImageAnnotatorContext } from "@msuite/image-annotator";
import type { TextAnnotation } from "@msuite/utils/types";
import { useTranslation } from "../../../localization";
import { Slider } from "../../../slider";

export function AnnotationToolbarSubMenuFontSize() {
	/** Context */
	const context = useImageAnnotatorContext();
	const selectedAnnotation = context.controller.getSelectedAnnotation() as TextAnnotation;

	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!selectedAnnotation) return null;

	/** Render */
	return (
		<div className="flex flex-col gap-1">
			<div className="flex flex-row justify-between items-center **:text-white! text-xs">
				<p>{t("image_annotator.font_size")}</p>
				<p>{selectedAnnotation.fontSize.toFixed(2)}px</p>
			</div>
			<Slider
				className="w-full"
				min={5}
				max={20}
				value={[selectedAnnotation.fontSize || 16]}
				onChange={([value]) => context.controller.handleOnUpdateSelection({ fontSize: value })}
			/>
		</div>
	);
}
